import styled from 'styled-components';
interface StyledDivProps {
  backgroundimage?: string;
  flipHorizontal?: boolean;
}
export const StyledDiv = styled.div<StyledDivProps>`
  background-image: url(${(props) => props.backgroundimage});
  background-size: cover;
  background-position: 35%;
  background-repeat: no-repeat;
  width: 100%;
  border-top: 4px solid #00B8E5;
`;